import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Button, Grid, Header, Tab } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/userActivity';
import { useStore } from '../../app/stores/store';
import ProfileEditForm from '../activities/form/ProfileEditForm';

// interface Props { //.o
//     profile: UserActivity;
// }

//function ProfileAbout(props: Props) { //.o
function ProfileAbout() { //.n
    const usStore = useStore();
    const [editProfileMode, setEditProfileMode] = useState(false);

    return (
        <Tab.Pane>
            <Grid>
                <Grid.Column width={16} >
                    <Header icon='user' content={`About ${usStore.profileStore.profile?.displayName}`} floated='left' />
                    {usStore.profileStore.isCurrentUser && (
                        <Button content={editProfileMode ? 'Cancel' : 'Edit Profile'} basic color='teal' floated='right' onClick={() => setEditProfileMode(!editProfileMode)} />
                    )}
                </Grid.Column>
                <Grid.Column width={16} >
                    {editProfileMode ? (
                        // <ProfileEditForm profile={usStore.profileStore.profile} /> //.o
                        <ProfileEditForm setEditProfileMode={setEditProfileMode} /> //'n
                    ) : (
                        //<p>{usStore.profileStore.profile.bio}</p>  //Hint: the style “whiteSpace: ‘pre-wrap” will preserve line breaks that are entered into the text area here if added to the span.
                        <span style={{ whiteSpace: 'pre-wrap' }} >{usStore.profileStore.profile?.bio}</span>
                   )}     
                </Grid.Column>
                
            </Grid>
        </Tab.Pane>
    )
}

export default observer(ProfileAbout);